module.exports = __webpack_public_path__ + "static/Nueng@2x.4d3af830.png";